<script>
import Gen from '@helper/Gen';
import BOGen from '@helper/BOGen';
import GlobalVue from '@helper/Global.vue';
export default {
    extends: GlobalVue,
    data(){
        return {
            input: {},
            passwordFieldType: 'password'
        }
    },
    computed:{
        yearcopy(){
            return Gen.yearCopy(this.web.yearcopy)
        }
    },
    mounted(){
        this.refreshVariable()
    },
    methods:{
        submit(e){
        if(e.btnLoading()) return;
            BOGen.apirest("/login", this.input, (err, resp)=>{
                e.btnUnloading()
                if(err) return console.log(err);
                if(resp.error){
                    return Gen.info(resp.message, 'danger')
                }
                Gen.putStorage("user", resp.user)
                Gen.putStorage("botk", resp.token)
                Gen.info(resp.message, 'success', 300).then(()=>{
                    this.$router.push({name:"BoDashboard"})
                })
            }, 'POST')
        },
        switchVisibility() {
          this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
        }
    }
}
</script>
<template>
<section id="wrapper">
    <div class="login-box">
        <div class="white-box">
            <div class="text-center p-20">
                <!-- <h1>SMERP</h1> -->
                <img :src="assets('bo_images','logo-smerp-green.png')" alt="SMERP Logo">
            </div>
            <VForm @resp="submit" class="form-horizontal" method="post">
            <h3 class="box-title m-b-20">Sign In</h3>
            <div class="info"></div>
            <div class="form-group ">
                <div class="col-xs-12">
                    <input class="form-control" type="text" v-model="input.username" name="username" required placeholder="username">
                </div>
            </div>
            <div class="form-group ">
                <div class="col-xs-12">
                    <div class="wrap_input">
                          <input id="password" :type="passwordFieldType" class="form-control" v-model="input.password" name="password" required placeholder="password">
                        <div class="input-group-append">
                            <span class="input-group-text btn_eye" @click="switchVisibility"><img :src="assets('bo_images','view.png')" alt="view" style="width: 25px;"></span>
                        </div>
                    </div>
                    
                    <!-- <input class="form-control" type="password" v-model="input.password" name="password" required placeholder="password"> -->
                </div>
            </div>
            <div class="form-group text-center">
                <div class="col-xs-12">
                    <button class="btn btn_green btn-lg btn-block text-uppercase waves-effect waves-light btn-loading" type="submit">Log in</button>
                </div>
            </div>
            </VForm>
        </div>
        <div class="col-sm-12 text-center copyright">
            <p>
                {{yearcopy}} &copy; SMERP. All Rights Reserved.
                <br/> Powered by <a target="_blank" href="http://www.lingkar9.com">lingkar9</a>
            </p>
        </div>
    </div>
</section>
</template>